import React, { FC, useEffect, useState } from 'react';
import { Grid } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { SCUIButton, SCUIAutoCompleteInput } from '../../../../atomic/atoms';
import { SCUIGeneralDrawerHeader } from '../../../../atomic/molecules';
import { ProductDetailServiceQuery } from '../../../../services/query';
import { PDSF } from './productDetailStoreFilter.classes';

interface IProps {
    listele?: any;
    cities: any;
    onClose?: any;
    setSelectedCounty?: any;
    setSelectedCity?: any;
    setFirstOpen?: any;
    selectedCityId?: any;
    urunOptionSizeRefArr?: any;
    setSelectedSize?: any;
}

export const ProductDetailStoreFilter: FC<IProps> = ({
    listele,
    cities,
    onClose,
    setSelectedCounty,
    setSelectedCity,
    setFirstOpen,
    selectedCityId,
    urunOptionSizeRefArr,
    setSelectedSize,
}) => {
    const { t } = useTranslation();
    const [cityId, setCityID] = useState(selectedCityId ? selectedCityId : 0);
    const [counties, setCounties] = useState<any[]>([]);
    const [countyId, setCountyID] = useState(0);
    const [selectedSizeRef, setSelectedSizeRef] = useState(0);

    const getStoreCounty = (cityId: any) => {
        ProductDetailServiceQuery.GetStoreCounty(cityId)
            .then((res: any) => {
                setCounties(res.data && [...[{ storeCountyId: 0, storeCountyName: t('general.all') }], ...res.data]);
            })
            .catch((error: any) => {
                console.log('Hata :>> ', error);
            });
    };

    useEffect(() => {
        if (cityId !== 0) {
            getStoreCounty(cityId);
        }
    }, [cityId]);

    return (
        <form
            className={PDSF.form}
            onSubmit={(e: any) => {
                e.preventDefault();
                listele(cityId, countyId, selectedSizeRef);
                setFirstOpen(false);
            }}
        >
            <div className={PDSF.container + ' commentFilterContainer'}>
                <Grid className={PDSF.gridRoot} container spacing={1}>
                    <SCUIGeneralDrawerHeader
                        header={t('general.filter')}
                        onClose={onClose}
                        rootClassName={PDSF.headerRoot}
                        titleClassName={PDSF.headerTitle}
                        closeIconClassName={PDSF.headerCloseIcon}
                    />
                    {cities && (
                        <Grid
                            size={{
                                xs: 12,
                                md: 12,
                                lg: 12,
                                xl: 12,
                            }}
                        >
                            <div className={PDSF.cityAutocompleteWrap}>
                                <SCUIAutoCompleteInput
                                    list={cities}
                                    onChange={(event: any, newValue: any) => {
                                        setCityID(newValue.storeCityId);
                                        setCounties([]);
                                        setSelectedCity(newValue.storeCityName);
                                    }}
                                    multiple={false}
                                    txtPlaceHolder={t('general.cityName')}
                                    searchValue="storeCityName"
                                />
                            </div>
                        </Grid>
                    )}
                    {counties && (
                        <Grid
                            size={{
                                xs: 12,
                                md: 12,
                                lg: 12,
                                xl: 12,
                            }}
                        >
                            <div className={PDSF.countyAutocompleteWrap}>
                                <SCUIAutoCompleteInput
                                    list={counties}
                                    onChange={(event: any, newValue: any) => {
                                        setCountyID(newValue.storeCountyId);
                                        setSelectedCounty(newValue.storeCountyName);
                                    }}
                                    multiple={false}
                                    txtPlaceHolder={'İlçe'}
                                    searchValue="storeCountyName"
                                    defValue={selectedCityId !== undefined ? selectedCityId : 0}
                                />
                            </div>
                        </Grid>
                    )}
                    <Grid
                        size={{
                            xs: 12,
                            md: 12,
                            lg: 12,
                            xl: 12,
                        }}
                    >
                        <div className={PDSF.sizeAutocompleteWrap}>
                            <SCUIAutoCompleteInput
                                list={urunOptionSizeRefArr}
                                onChange={(event: any, newValue: any) => {
                                    setSelectedSizeRef(newValue.urunOptionSizeRef);
                                    setSelectedSize(newValue.size);
                                }}
                                multiple={false}
                                txtPlaceHolder={'Beden'}
                                searchValue="size"
                            />
                        </div>
                    </Grid>
                    <br />
                    <Grid
                        className={PDSF.listButtonRow}
                        sx={{ marginLeft: 1 }}
                        size={{
                            xs: 12,
                            md: 12,
                            lg: 12,
                            xl: 12,
                        }}
                    >
                        <SCUIButton
                            className={PDSF.listButton}
                            text={t('general.list')}
                            type="primary"
                            sizeType="fixed"
                            buttonType="submit"
                            size={'l'}
                            fullwidth
                        />
                    </Grid>
                </Grid>
            </div>
        </form>
    );
};
